function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';
import Text from '../text';
import Title from '../title';
import { withModifiers } from '../../decorators';
import { ContextNested, getValidNestedChild } from '../../hooks/context-nested';

var Notification = function Notification(_ref) {
  var action = _ref.action,
      Tag = _ref.asTag,
      children = _ref.children,
      className = _ref.className,
      description = _ref.description,
      icon = _ref.icon,
      iconClass = _ref.iconClass,
      iconStatus = _ref.iconStatus,
      title = _ref.title,
      others = _objectWithoutProperties(_ref, ["action", "asTag", "children", "className", "description", "icon", "iconClass", "iconStatus", "title"]);

  var classes = classNames('notification', className, {
    'has-description': Boolean(description) || Boolean(children),
    'has-body': Boolean(description) || Boolean(children)
  });
  var iconClasses = classNames('is-block-mobile', iconClass);
  var innerClasses = classNames('call-to-action', action ? 'is-block-mobile' : 'is-hidden-mobile');
  var inner = action || Tag === 'a' && React.createElement(Icon, {
    name: "ui-arrow-right-r"
  }); // accessibility

  var isLiveAlert = className.includes('is-warning') || className.includes('is-error');
  var a11y = isLiveAlert && {
    role: 'status',
    'aria-live': 'polite'
  };

  var _contextNested = useContext(ContextNested);

  var _Tag = getValidNestedChild(_contextNested.isNestedInParent, Tag);

  return React.createElement(ContextNested.Provider, {
    value: {
      isNestedInParent: _Tag,
      isNestedInlink: Tag === 'a'
    }
  }, React.createElement(_Tag, _extends({
    className: classes
  }, a11y, others), icon && React.createElement(Icon, {
    className: iconClasses,
    name: icon,
    status: iconStatus
  }), React.createElement("div", {
    className: "body is-block-mobile"
  }, title && React.createElement(Title, {
    size: 5
  }, title), description && React.createElement(Notification.Text, {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), children), inner && React.createElement("div", {
    className: innerClasses
  }, inner)));
};

Notification.propTypes = {
  action: PropTypes.element,
  children: PropTypes.any,
  className: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  iconStatus: PropTypes.string,
  iconClass: PropTypes.string,
  title: PropTypes.string.isRequired,
  asTag: PropTypes.string
};
Notification.defaultProps = {
  asTag: 'div'
};
Notification.Text = Text;
export default withModifiers(Notification);